import { render, staticRenderFns } from "./detailReport.vue?vue&type=template&id=8613fb06&scoped=true&"
import script from "./detailReport.vue?vue&type=script&lang=js&"
export * from "./detailReport.vue?vue&type=script&lang=js&"
import style0 from "./detailReport.vue?vue&type=style&index=0&id=8613fb06&prod&lang=css&"
import style1 from "./detailReport.vue?vue&type=style&index=1&id=8613fb06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8613fb06",
  null
  
)

export default component.exports